import React from "react";
import styled from "styled-components";
import THEME from "theme";

import type { ButtonProps } from "@ntemarked/mittne-components/dist/Button/Button";
import Button from "@ntemarked/mittne-components/dist/Button/Button";

export const DangerButton: React.FC<ButtonProps> = (props) => {
	return (
		<Button
			{...props}
			colors={{
				background: THEME.dangerButton.background,
				backgroundPressed: THEME.dangerButton.hoverBackground,
				border: THEME.dangerButton.border,
			}}
		/>
	);
};

export const DeleteButton = styled(DangerButton)`
	height: 40px;
	width: 200px;
	margin-left: 16px;
	margin-top: 16px;
	padding: 0;
	line-height: 0;
	border: none;
`;
